var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveIconOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4853",
    "data-name": "Rectangle 4853",
    width: 16.218,
    height: 16.226,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13285",
    "data-name": "Group 13285",
    transform: "translate(-1421 -437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13222",
    "data-name": "Group 13222",
    transform: "translate(1421 437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.875,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13223",
    "data-name": "Group 13223",
    transform: "translate(1425.009 441.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12174",
    "data-name": "Group 12174",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45228",
    "data-name": "Path 45228",
    d: "M0,140.583a2.965,2.965,0,0,1,.266-.365c.577-.587,1.162-1.167,1.744-1.749a.481.481,0,0,1,.792,0c.052.052.106.1.157.157a.456.456,0,0,1,0,.689c-.22.228-.444.451-.693.7h2.53a.473.473,0,0,1,.528.525c0,.084,0,.169,0,.253a.464.464,0,0,1-.486.487c-.8,0-1.6,0-2.407,0h-.2c.037.046.058.078.085.105.2.2.4.4.6.606a.457.457,0,0,1,0,.688c-.065.069-.133.136-.2.2a.46.46,0,0,1-.7,0c-.361-.356-.717-.716-1.076-1.074-.22-.22-.445-.436-.659-.662A4.531,4.531,0,0,1,0,140.773v-.19",
    transform: "translate(0 -132.53)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45229",
    "data-name": "Path 45229",
    d: "M140.335,268.285c-.117-.1-.242-.183-.349-.289q-.839-.83-1.67-1.667c-.286-.287-.275-.507-.005-.8.355-.391.641-.4.987,0a4.048,4.048,0,0,0,.562.528v-.166c0-.792.009-1.584,0-2.376a.537.537,0,0,1,.551-.55c.579-.013.74.182.725.722-.02.723-.005,1.446-.005,2.17v.2c.2-.206.39-.376.555-.562.375-.424.654-.378,1,0a.488.488,0,0,1,0,.793q-.9.9-1.8,1.8a2.939,2.939,0,0,1-.254.2Z",
    transform: "translate(-132.383 -252.059)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45230",
    "data-name": "Path 45230",
    d: "M265.96,141.333c-.884,0-1.718-.012-2.551.006a.532.532,0,0,1-.576-.569c-.006-.534.151-.726.719-.709.77.023,1.54.006,2.337.006a1.156,1.156,0,0,0-.08-.1c-.2-.2-.4-.393-.594-.592a.457.457,0,0,1-.005-.7c.069-.073.139-.144.213-.212a.452.452,0,0,1,.666,0c.188.177.367.364.55.547q.661.66,1.321,1.32a.488.488,0,0,1,0,.793q-.889.89-1.78,1.779a.484.484,0,0,1-.769,0c-.413-.376-.433-.638-.008-1.017.183-.164.351-.346.559-.552",
    transform: "translate(-251.943 -132.583)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45231",
    "data-name": "Path 45231",
    d: "M140,2.206c-.241.242-.451.454-.663.664a.491.491,0,0,1-.782,0c-.408-.369-.4-.63,0-1.01.562-.535,1.1-1.094,1.65-1.643a.5.5,0,0,1,.817,0l1.8,1.8a.486.486,0,0,1,0,.782c-.36.393-.622.436-1.007.006-.164-.184-.349-.35-.553-.553v.2q0,1.172,0,2.344c0,.369-.17.536-.544.537H140.5a.468.468,0,0,1-.5-.506q0-1.2,0-2.407Z",
    transform: "translate(-132.523 0)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45232",
    "data-name": "Path 45232",
    d: "M166.462,165.328a1.266,1.266,0,1,1-1.276,1.257,1.268,1.268,0,0,1,1.276-1.257",
    transform: "translate(-158.342 -158.478)",
    fill: "#ef7b13"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIconOrange);
export default __webpack_public_path__ + "static/media/move-icon-orange.eb1107a980bd239243bb749e988da660.svg";
export { ForwardRef as ReactComponent };